export default "__VITE_ASSET__BxkV9PTk__"